import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederVgsUrDto from '../Models/VeilederVgsUrDto';

const ja = 'e1-ja';
const nei = 'e2-nei';

const eValg: RadioButtonValgModel<VeilederVgsUrDto>[] = [
    {
        id: 'e1',
        value: ja,
        tekst: 'valgBetalerSkolepenger',
    },
    {
        id: 'e2',
        value: nei,
        tekst: 'valgBetalerIkkeSkolepenger',
    },
];

export default {
    e1_ja: ja,
    e2_nei: nei,
    eValg,
};
